import * as FwDatas from "../FwDatas.ts";
import { sleep } from "../lib/Async.ts";
import * as Storage from "../lib/Storage.ts";
import * as modal from "../util/modal.ts";
import * as Confetti from "../lib/Confetti.ts";
import { checkPremiumEligibility } from "../homehub-activation/premium-eligibility-service.ts";

const POLL_INTERVAL_MS = 1000;
const POLL_ATTEMPTS = 30;

/**
 * Shows the waiting modal after a 2Checkout return and polls the account credits
 * until the server has granted Premium. The purchase is confirmed server-side,
 * so this only observes the outcome — it must never assert the purchase itself.
 *
 * Resolves true once Premium is active, false when the wait times out.
 */
export async function waitForPremium(): Promise<boolean> {
  Storage.sessionSet("waitingpremium", (new Date()).toISOString());

  const TPL = await import("./waitingpremium.mustache");
  const waitingModal = modal.openDomModal(TPL);
  waitingModal.classList.add("blurred-veil");

  let granted = false;
  for (let attempt = 0; attempt < POLL_ATTEMPTS && !granted; attempt++) {
    await sleep(POLL_INTERVAL_MS);
    granted = await isPremiumActive();
  }

  // The cached account state was read before the purchase, so it is dropped to
  // force a refetch of the premium rights on the next navigation.
  if (granted) FwDatas.setState(undefined);

  modal.closeDomModal(waitingModal);
  if (granted) Confetti.start(2000);
  return granted;
}

// A failed read is not an answer, so the wait simply continues.
async function isPremiumActive(): Promise<boolean> {
  try {
    return (await checkPremiumEligibility()).status === "active";
  } catch (e){
    console.log(e)
    return false;
  }
}
